import React from 'react';
import { connect } from 'react-redux';
import { change, formValueSelector, reset } from 'redux-form';
import PropTypes from 'prop-types';

import './stylesheets/main.css';

import Gender from './FormPages/Gender';
import WeeklyActivityLevel from './FormPages/WeeklyActivityLevel';
import WeightHeight from './FormPages/WeightHeight';
import Smoking from './FormPages/Smoking';
import Alcohol from './FormPages/Alcohol';
import AllResults from './FormPages/AllResults';

import changePage from '../../Actions/Campaign/changePage';

class CampaignForm extends React.Component {
  componentWillMount() {
    // check localstorage
    if (localStorage.getItem('personalInfo') !== null) {
      const storagePersonalData = JSON.parse(localStorage.getItem('personalInfo'));
      if (storagePersonalData.linkBack) {
        this.props.dispatch(change('campaign', 'campaign[gender]', storagePersonalData.gender));
        this.props.dispatch(change('campaign', 'campaign[activity_times]', storagePersonalData.activity.toString()));
        this.props.dispatch(change('campaign', 'campaign[weight_weight]', storagePersonalData.weight.toString()));
        this.props.dispatch(change('campaign', 'campaign[weight_height]', storagePersonalData.height.toString()));
        this.props.dispatch(change('campaign', 'campaign[smoking_quantity]', storagePersonalData.smokingamount));
        this.props.dispatch(change('campaign', 'campaign[alcohol_units_per_week]', storagePersonalData.units.toString()));
        this.props.dispatch(changePage(6));
      }
    }
    // this.props.dispatch(changePage(6));
  }

  nextPage = () => {
    const page = this.props.page + 1;
    this.props.dispatch(changePage(page));
  }

  reset = () => {
    this.props.dispatch(reset('campaign'));
    this.props.dispatch(changePage(1));
  }

  render = () => {
    const { page } = this.props;
    return (
      <div className="wrap">
        {page === 1 && <Gender onSubmit={this.nextPage} />}
        {page === 2 && <WeeklyActivityLevel onSubmit={this.nextPage} activity={this.props.activityLevel} />}
        {page === 3 && <WeightHeight onSubmit={this.nextPage} dispatch={this.props.dispatch} />}
        {page === 4 && <Smoking smokingAmount={this.props.smokingAmount} onSubmit={this.nextPage} />}
        {page === 5 && <Alcohol units_per_week={this.props.units_per_week} previousPage={this.previousPage} onSubmit={this.nextPage} />}
        {page === 6 && <AllResults
          gender={this.props.gender}
          activity={this.props.activityLevel}
          height={this.props.height}
          weight={this.props.weight}
          units={this.props.units_per_week}
          smokingamount={this.props.smokingAmount}
          dispatch={this.props.dispatch}
          resetFunc={this.reset}
        />}
      </div>
    );
  }
}

const selector = formValueSelector('campaign');

CampaignForm.propTypes = {
  gender: PropTypes.string.isRequired,
  activityLevel: PropTypes.number.isRequired,
  weight: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  smokingAmount: PropTypes.string.isRequired,
  units_per_week: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(state => ({
  gender: selector(state, 'campaign[gender]') || 'Prefer not to say',
  activityLevel: parseInt(selector(state, 'campaign[activity_times]'), 10) || 0,
  weight: parseFloat(selector(state, 'campaign[weight_weight]')) || 110,
  height: parseFloat(selector(state, 'campaign[weight_height]')) || 134,
  smokingAmount: selector(state, 'campaign[smoking_quantity]') || '0',
  units_per_week: parseInt(selector(state, 'campaign[alcohol_units_per_week]'), 10) || 0,
  page: state.campaignPage,
}))(CampaignForm);



// WEBPACK FOOTER //
// ./src/Components/Campaign/index.jsx